/**
 * Mattress Compare Section JavaScript
 * Handles toggle for advanced rows and optional sticky header
 */

(function() {
  'use strict';

  const initCompareSection = () => {
    const compareSections = document.querySelectorAll('.mattress-compare-section');
    
    compareSections.forEach(section => {
      const toggleButton = section.querySelector('.compare-toggle-advanced');
      // Marked advanced rows (regardless of initial inline styles)
      const advancedRows = section.querySelectorAll('.compare-row-advanced');
      const tableWrapper = section.querySelector('.compare-table-wrapper');
      const stickyHeaderEnabled = tableWrapper && tableWrapper.dataset.stickyHeader === 'true';
      
      // Handle advanced rows toggle
      if (toggleButton) {
        // If there are no advanced rows, hide the toggle UI (avoid confusing UX)
        if (!advancedRows || advancedRows.length === 0) {
          const wrapper = toggleButton.closest('.compare-advanced-toggle-wrapper');
          if (wrapper) wrapper.style.display = 'none';
        }

        if (!advancedRows || advancedRows.length === 0) return;

        // Always start collapsed: advanced rows hidden until user clicks "Show more".
        let isExpanded = false;
        const expandText = toggleButton.dataset.expandText || 'Show more';
        const toggleText = toggleButton.dataset.toggleText || 'Show less';

        const applyState = () => {
          advancedRows.forEach(row => {
            if (isExpanded) {
              row.style.display = '';
              row.removeAttribute('aria-hidden');
            } else {
              row.style.display = 'none';
              row.setAttribute('aria-hidden', 'true');
            }
          });
          toggleButton.setAttribute('aria-expanded', isExpanded.toString());
          toggleButton.textContent = isExpanded ? toggleText : expandText;
        };
        
        const handleToggle = () => {
          isExpanded = !isExpanded;
          applyState();
        };
        
        toggleButton.addEventListener('click', handleToggle);

        // Force initial collapsed state (don’t rely on Liquid inline styles)
        applyState();
      }

      // Handle sticky header on scroll (if enabled)
      if (stickyHeaderEnabled) {
        const thead = section.querySelector('.compare-table thead');
        const table = section.querySelector('.compare-table');
        
        if (thead && table) {
          let isSticky = false;
          
          const handleScroll = () => {
            const rect = tableWrapper.getBoundingClientRect();
            const shouldBeSticky = rect.top < 0 && rect.bottom > window.innerHeight;
            
            if (shouldBeSticky !== isSticky) {
              isSticky = shouldBeSticky;
              
              if (isSticky) {
                thead.classList.add('sticky-header');
                const headerCells = thead.querySelectorAll('th:not(.sticky-col)');
                headerCells.forEach((cell, index) => {
                  const tbodyCell = table.querySelector(`tbody tr:first-child td:nth-child(${index + 2})`);
                  if (tbodyCell) {
                    cell.style.width = tbodyCell.offsetWidth + 'px';
                  }
                });
              } else {
                thead.classList.remove('sticky-header');
              }
            }
          };
          
          // Use requestAnimationFrame for smooth scrolling
          let ticking = false;
          const onScroll = () => {
            if (!ticking) {
              window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
              });
              ticking = true;
            }
          };
          
          window.addEventListener('scroll', onScroll, { passive: true });
          handleScroll(); // Initial check
        }
      }
    });
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompareSection);
  } else {
    initCompareSection();
  }
})();
